$(function () {
  var doctorsExperienceSlider = new Swiper('#doctorsExperienceSlider', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.doctors-experience-pagination',
      type: 'bullets',
      clickable: true,
    },
  });
});

